<div *ngIf="type === 'order-sheet'">
    <fc-order-sheet></fc-order-sheet>
</div>

<div *ngIf="type === 'shopping-cart'">
    <fc-shopping-cart (onOrderSent)="onOrderSent.emit()"></fc-shopping-cart>
</div>

<div *ngIf="type === 'download-cart'">
    <fc-download-cart></fc-download-cart>
</div>

<div class="main-content-drawer" *ngIf="type === 'main-content-drawer'">
    <fc-main-content-drawer></fc-main-content-drawer>
</div>
